import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #333;
  color: white;
  padding: 3rem 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

const FooterLink = styled(Link)`
  color: #ddd;
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: #ff6b6b;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 1.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: #ff6b6b;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #555;
  color: #ddd;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Essex Ice Cream</h3>
          <p>Handcrafted ice cream made with love in Essex, MA since 2025.</p>
        </FooterSection>

        <FooterSection>
          <h3>Quick Links</h3>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/menu">Menu</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterSection>

        <FooterSection>
          <h3>Visit Us</h3>
          <p>123 Main Street</p>
          <p>Essex, MA 01929</p>
          <p>Phone: (978) 555-0123</p>
          <p>Email: info@essexicecream.com</p>
        </FooterSection>

        <FooterSection>
          <h3>Follow Us</h3>
          <p>Stay updated with our latest flavors and events!</p>
          <SocialLinks>
            <SocialLink href="#" target="_blank" rel="noopener noreferrer">Facebook</SocialLink>
            <SocialLink href="#" target="_blank" rel="noopener noreferrer">Instagram</SocialLink>
            <SocialLink href="#" target="_blank" rel="noopener noreferrer">Twitter</SocialLink>
          </SocialLinks>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        © {new Date().getFullYear()} Essex Ice Cream. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
}

export default Footer;
